export class Numbers {
    constructor() {
        this.supportNumbers = {
            sales: {
                title: 'Contact Sales Support',
                contactInfo: {
                    agent: {
                        phoneNumber: '(877) 617-5589',
                        timeOpen: 'Monday-Friday 8:00 a.m. - 5:00 p.m. CST'
                    },
                    broker: {
                        phoneNumber: '(800) 693-6083',
                        timeOpen: 'Monday-Friday 8:00 a.m. - 5:00 p.m. CST'
                    }
                }
            },
            tech: {
                title: 'Contact the Field Assistance Center',
                contactInfo: {
                    agent: {
                        phoneNumber: '(800) 228-7669',
                        timeOpen: 'Monday-Friday 7:00 am - 5:30 pm CST'
                    },
                    broker: {
                        phoneNumber: '(800) 847-9785',
                        timeOpen: 'Monday-Friday 7:00 a.m. - 5:30 p.m. CST'
                    },
                    employee: {
                        title: 'Contact the Service Desk',
                        phoneNumber: '(402) 351-4357',
                        timeOpenWeekday: 'Monday-Friday 6:00 am - 5:30 pm CST',
                        timeOpenWeekend: 'Saturday 7:00 am - 1:00 pm CST'
                    }
                }
            }
        };

        const portalContainer = Array.from(document.getElementsByClassName('portal-main-Content'));

        for(let salesSupport of Array.from(document.getElementsByClassName('sales-SupportCall'))) {
            if (portalContainer[0].classList.contains('is-agency')) {
                salesSupport.innerHTML = this.buildTemplate(
                    this.supportNumbers.sales.title,
                    this.supportNumbers.sales.contactInfo.agent.phoneNumber,
                    this.supportNumbers.sales.contactInfo.agent.timeOpen
                );
            } else if (portalContainer[0].classList.contains('is-brokerage')) {
                salesSupport.innerHTML = this.buildTemplate(
                    this.supportNumbers.sales.title,
                    this.supportNumbers.sales.contactInfo.broker.phoneNumber,
                    this.supportNumbers.sales.contactInfo.broker.timeOpen
                );
            } else {
                salesSupport.innerHTML = this.defaultTemplate(
                    this.supportNumbers.sales.title,
                    this.supportNumbers.sales.contactInfo.agent.phoneNumber,
                    this.supportNumbers.sales.contactInfo.broker.phoneNumber,
                    this.supportNumbers.sales.contactInfo.agent.timeOpen
                );
            }
        }

        for(let techSupport of Array.from(document.getElementsByClassName('tech-SupportCall'))) {
            if (portalContainer[0].classList.contains('is-agency')) {
                techSupport.innerHTML = this.buildTemplate(
                    this.supportNumbers.tech.title,
                    this.supportNumbers.tech.contactInfo.agent.phoneNumber,
                    this.supportNumbers.tech.contactInfo.agent.timeOpen
                );
            } else if (portalContainer[0].classList.contains('is-brokerage')) {
                techSupport.innerHTML = this.buildTemplate(
                    this.supportNumbers.tech.title,
                    this.supportNumbers.tech.contactInfo.broker.phoneNumber,
                    this.supportNumbers.tech.contactInfo.broker.timeOpen
                );
            } else if (portalContainer[0].classList.contains('is-employee')) {
                techSupport.innerHTML = this.employeeTemplate(
                    this.supportNumbers.tech.contactInfo.employee.title,
                    this.supportNumbers.tech.contactInfo.employee.phoneNumber,
                    this.supportNumbers.tech.contactInfo.employee.timeOpenWeekday,
                    this.supportNumbers.tech.contactInfo.employee.timeOpenWeekend
                );
            } else {
                techSupport.innerHTML = this.defaultTemplate(
                    this.supportNumbers.tech.title,
                    this.supportNumbers.tech.contactInfo.agent.phoneNumber,
                    this.supportNumbers.tech.contactInfo.broker.phoneNumber,
                    this.supportNumbers.tech.contactInfo.agent.timeOpen
                );
            }
        }
    }

    buildTemplate(title, number, hours) {
        return `<h2 class="core-u-fontBlueDark core-u-mB1">${title}</h2>
        <p class="core-u-fontWeight500 core-u-fontSmall core-u-fontGray">${hours}</p>
        <p class="core-u-fontWeight300">Please Call: <span class="core-u-fontWeight600"><a href="tel:1${number.replace(/[\(\) -]/g, '')}">${number}</a></span></p>`;
    }

    defaultTemplate(title, numberAgent, numberBroker, hours) {
        return `<h2 class="core-u-fontBlueDark core-u-mB1">${title}</h2>
        <p class="core-u-fontWeight500 core-u-fontSmall core-u-fontGray">${hours}</p>
        <p class="core-u-fontWeight300">Career Agents: <span class="core-u-fontWeight600"><a href="tel:1${numberAgent.replace(/[\(\) -]/g, '')}">${numberAgent}</a></span></p>
        <p class="core-u-fontWeight300">Independent Producers: <span class="core-u-fontWeight600"><a href="tel:1${numberBroker.replace(/[\(\) -]/g, '')}">${numberBroker}</a></span></p>`;
    }

    employeeTemplate(title, number, timeOpenWeekday, timeOpenWeekend) {
        return `<h2 class="u-fontBlueDark u-mB1">${title}</h2>
        <p class="u-fontWeight500 u-fontSmall u-fontGray">${timeOpenWeekday}<br>
        ${timeOpenWeekend}</p>
        <h6><span class="u-fontWeight300">Please Call:</span> <span class="u-fontWeight600"><a href="tel:1${number.replace(/[\(\) -]/g, '')}">${number}</a></span></h6>`;
    }
}



// WEBPACK FOOTER //
// ./src/modules/Shared/Numbers/index.js